<template>
  <div
    :class="['group_snb',{ fold : isFold }]">
    <div v-if="!serviceMenu.isUngroup" class="head_snb">
      <button class="btn_fold" @click="onClickFold()">
        <strong class="tit_snb">{{ getIsActiveGnb ? serviceMenu.title : serviceMenu.foldTitle }}</strong>
        <IconSvg iconName="arrow_top" size="10" iconColor="#555"/>
      </button>
    </div>
    <div class="body_snb">
      <ul class="list_snb">
        <SnbItem
          v-for="snbMenu in serviceMenu.menuList"
          :key="snbMenu.title"
          :serviceId="serviceMenu.id"
          :snbMenu="snbMenu"/>
      </ul>
    </div>
  </div>
</template>

<script>
import { menuData } from '@/constants/menuData';
import SnbItem from '@lemontree-ai/lemontree-admin-common-front/components/layout/header/SnbItem'
import IconSvg from '@lemontree-ai/lemontree-admin-common-front/components/common/icon/IconSvg';
import { mapGetters } from 'vuex';

export default{
  name:'SnbList',
  props:{
    serviceMenu:Object,
    index: Number
  },
  components:{
    SnbItem,
    IconSvg
  },
  mounted(){
    this.isFold = this.serviceMenu.isFold;
  },
  data(){
    return{
      isFold:false
    }
  },
  computed:{
    ...mapGetters('commonGnb', [ 'getIsActiveGnb' ]),
  },
  watch:{
    isFold(){
      menuData[this.index].isFold = this.isFold;
    }
  },
  methods:{
    onClickFold(){
      this.isFold = !this.isFold
    },
  }
}
</script>

<style lang="scss" scoped>
.group_snb{border-top:1px solid $DEFAULT_BORDER}
.group_snb .head_snb{border-bottom:1px solid $DEFAULT_BORDER}
.group_snb .btn_fold{display:block;position:relative;width:100%}
.group_snb .tit_snb{display:inline-block;padding:10px 8px 8px;font-weight:500;font-size:12px;line-height:16px;color:$CONTENT_TEXT;letter-spacing:-0.02em;vertical-align:top}
.group_snb .icon_arrow_top{display:none;position:absolute;top:12px;right:10px}
.group_snb .body_snb{overflow:hidden;max-height:1240px;}
/* .group_snb .body_snb:first-child{border-top:1px solid #e1e1e1} */
.group_snb .list_snb{padding:5px 5px}

.group_snb + .group_snb{margin-top:-1px}
.group_snb:last-child{border-bottom:1px solid $DEFAULT_BORDER}

/* activeSnb */
.active_snb .group_snb .btn_fold{text-align:left}
.active_snb .group_snb .tit_snb{padding:10px 17px 8px}
.active_snb .group_snb .icon_arrow_top{display:block}

/* fold */
// .group_snb.fold .head_snb{background-color:$DISABLED_BG}
// .group_snb.fold .tit_snb{color:$DISABLED_TEXT}
.group_snb.fold .icon_arrow_top{transform:rotate(180deg)}
// .group_snb.fold .icon_arrow_top ::v-deep g{fill:$DISABLED_ICON}
.group_snb.fold .body_snb{max-height:0}

@media (prefers-color-scheme: dark) {
  .group_snb{border-top:1px solid $DEFAULT_BORDER_DARK}
  .group_snb:last-child{border-bottom:1px solid $DEFAULT_BORDER_DARK}
  .group_snb .head_snb{border-bottom:1px solid $DEFAULT_BORDER_DARK}
  .group_snb .tit_snb{color:$TITLE_TEXT_DARK}

  /* fold */
  // .group_snb.fold .head_snb{background-color:$DISABLED_BG_DARK}
  // .group_snb.fold .tit_snb{color:$DISABLED_TEXT_DARK}
  // .group_snb.fold .icon_arrow_top ::v-deep g{fill:$DISABLED_ICON_DARK}
  // .group_snb .body_snb:first-child{border-top:1px solid #404040}
}
</style>